import axios from 'axios';

// API base URL:
// - If `REACT_APP_API_URL` is set, it wins.
// - Otherwise, use a relative `/api` path (works with CRA dev proxy and with prod deployments
//   where frontend + backend share the same origin).
const API_BASE =
  process.env.REACT_APP_API_URL ||
  '/api';

const api = axios.create({
  baseURL: API_BASE,
  timeout: 30000,
});

api.interceptors.request.use(cfg => {
  const token = localStorage.getItem('token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  res => res,
  err => {
    if (err.response && err.response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      if (window.location.pathname !== '/login') window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;
